import React from 'react';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import './config/ReactotronConfig';

import Routes from './routes';
import history from './services/history';
import Notification from '~/components/Notifications/PopUp';

import { store, persistor } from './store';
import AppHooks from './hooks';

import Maincss from './styles/main';
import { Body } from './styles/styles';

function App() {
  return (
    <Body>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <AppHooks>
            <Router history={history}>
              <Routes />
            </Router>
          </AppHooks>

          <Notification />
        </PersistGate>
      </Provider>
      <Maincss />
      <ToastContainer autoClose={3000} />
    </Body>
  );
}

export default App;
